module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_02_6DD79_1SE_G1W.b99a3d59.png";